import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from "react-responsive";
import styles from "./WelcomePopupImage.module.scss";
export const WelcomePopupImage = ({ alt = "", largeSrc, mediumSrc, smallSrc }) => {
    const isSmallScreen = useMediaQuery({ query: "(max-width: 479px)" });
    const isMediumScreen = useMediaQuery({ query: "(max-width: 959px)" });
    let srcToUse = largeSrc;
    if (isSmallScreen && smallSrc) {
        srcToUse = smallSrc;
    }
    else if (isMediumScreen && mediumSrc) {
        srcToUse = mediumSrc;
    }
    return (_jsx("div", { className: styles.mainImageContainer, children: _jsx("img", { className: styles.mainImage, src: srcToUse, alt: alt, loading: "lazy" }) }));
};
//# sourceMappingURL=WelcomePopupImage.js.map